export function isCorrectFileFormat(acceptedFileFormats: string = '', files: Array<File> = []): boolean {
    return [...files].some((file: File) => {
        const fileNameParts = file?.name?.split('.');
        const fileExt = fileNameParts[fileNameParts.length - 1];

        return acceptedFileFormats.includes(fileExt);
    });
}
